import { useState } from 'react'
import { useParams } from 'react-router-dom'
import styled from 'styled-components'
import useTranslation from '../../../hooks/useTranslation'
import { media } from '../../../styles/media'
import CardSelect from '../../../components/select/CardSelect'
import WarehouseLayoutDesigner from '../../../components/warehouse/WarehouseLayoutDesigner'

const PageWrap = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
`

const Header = styled.div`
    padding: 1rem 1.5rem 0.75rem;
    border-bottom: 1px solid ${p => p.theme.area.lightBorder};
    display: flex;
    align-items: center;
    gap: 1rem;
    flex-shrink: 0;

    ${media.phone} { padding: 0.6rem 0.75rem 0.5rem; }
`

// On a phone the cards are the header. The title says what the page already
// says — the warehouse module's own nav got the user here — and it is the only
// thing competing with the cards for the width they need to scroll in.
const Title = styled.h2`
    font-size: 1.1rem;
    font-weight: 600;
    color: ${p => p.theme.font.color};
    margin: 0;
    flex-shrink: 0;

    ${media.phone} { display: none; }
`

// min-width: 0 is what lets the card row scroll rather than push the header wide.
const PickerWrap = styled.div`
    flex: 1;
    min-width: 0;
`

const Body = styled.div`
    flex: 1;
    min-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
`

function WarehouseLayoutPage() {
    const { warehouseId: paramId } = useParams()
    const { t } = useTranslation()
    // The picker owns both halves of the choice: it restores the warehouse from
    // the last visit, and it resolves a URL param to the record behind it.
    const [warehouse, setWarehouse] = useState(null)

    return (
        <PageWrap>
            <Header>
                <Title>{t('warehouse.layout.title')}</Title>
                <PickerWrap>
                    <CardSelect
                        configRef='warehouseSelect'
                        valueId={warehouse?.id || paramId || ''}
                        onSelect={setWarehouse}
                        testId='warehouse.layout.select'
                    />
                </PickerWrap>
            </Header>
            <Body>
                {warehouse
                    ? <WarehouseLayoutDesigner
                        // Keyed on the warehouse: a different one is a different
                        // drawing, so it gets a fresh canvas rather than the
                        // previous warehouse's pan, zoom and selection.
                        key={warehouse.id}
                        warehouseId={warehouse.id}
                        warehouseCode={warehouse.code || ''}
                      />
                    : null
                }
            </Body>
        </PageWrap>
    )
}

export default WarehouseLayoutPage
